import { render, staticRenderFns } from "./GraphObject.vue?vue&type=template&id=6bbbb0cc&scoped=true&"
import script from "./GraphObject.vue?vue&type=script&lang=ts&"
export * from "./GraphObject.vue?vue&type=script&lang=ts&"
import style0 from "./GraphObject.vue?vue&type=style&index=0&id=6bbbb0cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbbb0cc",
  null
  
)

export default component.exports